<template>
  <div class="orders">
    <v-overlay
      absolute
      :value="conceptsLoading || kitchensLoading || platformsLoading || countriesLoading"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Filters
      :concepts="sortedConcepts"
      :kitchens="sortedKitchens"
      :platforms="sortedPlatforms"
      :countries="sortedCountries"
      v-on:search="search"
    />
    <v-container>
      <Table
        :orders="orders"
        :isLoading="ordersLoading"
        :concepts="concepts"
        :kitchens="kitchens"
        :platforms="platforms"
        :countries="sortedCountries"
        v-on:openDetails="openDetails"
      />
    </v-container>
    <v-dialog v-model="details" max-width="500px">
      <Details :order="selectedOrder" />
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Filters from "@/components/Orders/Filters";
import Table from "@/components/Orders/Table";
import Details from "@/components/Orders/Details";

export default {
  components: { Filters, Table, Details },
  data: () => {
    return {
      selectedConcept: null,
      selectedOrder: null,
      details: false,
      snackbar: false,
      error: "",
    };
  },
  computed: {
    ...mapState({
      orders: (state) => state.orders.all,
      ordersLoading: (state) => state.orders.fetchAll.pending,
      concepts: (state) => state.restaurant.concepts,
      conceptsLoading: (state) => state.restaurant.fetchAllConcepts.pending,
      kitchens: (state) => state.restaurant.kitchens,
      kitchensLoading: (state) => state.restaurant.fetchAllKitchens.pending,
      platforms: (state) => state.restaurant.platforms,
      platformsLoading: (state) => state.restaurant.fetchAllPlatforms.pending,
      countries: (state) => state.restaurant.countries,
      countriesLoading: (state) => state.restaurant.fetchAllCountries.pending,
    }),
    sortedConcepts() {
      let _concepts = [...this.concepts];
      return _concepts.sort((a, b) => (a.label > b.label ? 1 : -1));
    },
    sortedKitchens() {
      let _kitchens = [...this.kitchens];
      return _kitchens.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
    sortedPlatforms() {
      let _platforms = [...this.platforms];
      return _platforms.sort((a, b) => (a.label > b.label ? 1 : -1));
    },
    sortedCountries() {
      let _countries = [...this.countries];
      return _countries.sort((a, b) => (a.label > b.label ? 1 : -1));
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("orders", {
      fetchAllOrders: "fetchAll",
      fetchOneOrder: "fetchOne",
    }),
    ...mapActions("restaurant", {
      fetchAllConcepts: "fetchAllConcepts",
      fetchAllKitchens: "fetchAllKitchens",
      fetchAllPlatforms: "fetchAllPlatforms",
      fetchAllCountries: "fetchAllCountries",
    }),
    refresh() {
      this.fetchAllConcepts().catch((error) => {
        this.setError(error);
      });
      this.fetchAllKitchens().catch((error) => {
        this.setError(error);
      });
      this.fetchAllPlatforms().catch((error) => {
        this.setError(error);
      });
      this.fetchAllCountries().catch((error) => {
        this.setError(error);
      });
    },
    search(number, day, conceptUuid, kitchenUuid, platformUuid, country_code) {
      let payload = {
        number: number,
        day: day,
        conceptUuid: conceptUuid,
        kitchenUuid: kitchenUuid,
        platformUuid: platformUuid,
        country_code: country_code,
        summary: true,
      };
      this.fetchAllOrders(payload).catch((error) => {
        this.setError(error);
      });
    },
    openDetails(uuid) {
      this.fetchOneOrder({ uuid: uuid })
        .then((data) => {
          this.selectedOrder = data;
          this.details = true;
        })
        .catch((error) => {
          this.setError(error);
        });
    },
  },
  created() {
    this.refresh();
  },
};
</script>
